/*
  RenderData
  - handles the different types of data rendering for the Grid.Table component
*/
import React from "react";
import Row from '../row';
import { GridNoResultsSplash, GridErrorSplash, GridLoadingSplash, GridNoColumnsSplash, GridRenderData } from '../../../molecules';
import useDataGrid from "../use-data-grid";

export default function RenderData() {

  const grid = useDataGrid();

  return (
    <>
      {
        (grid.areAllColumnsDisabled()) ?
          <GridNoColumnsSplash
            width={grid.width}
            height={grid.splashHeight}
          />

          : (grid.isLoading) ?
            <GridLoadingSplash
              width={grid.width}
              height={grid.splashHeight}
            />

            : (grid.fetchStatusCode !== 'No Errors Detected') ?
              <GridErrorSplash
                width={grid.width}
                height={grid.splashHeight}
                error={grid.fetchStatusCode}
              />

              : (grid.cachedTableData.length === 0 || grid.tableData.length === 0) ?
                <GridNoResultsSplash
                  width={grid.width}
                  height={grid.splashHeight}
                />

                : <>
                  <GridRenderData
                    as={(grid.CustomRowComp) ? grid.CustomRowComp : Row}
                    activePage={grid.activePage}
                    pageSize={grid.pagingOptions.size}
                    data={grid.tableData}
                    onScrollBottom={grid.onScrollBottom}
                    onScrollTop={grid.onScrollTop}
                    gridType={'table'}
                    onPageEnd={grid.setIsOnPageEnd}
                  />
                </>
      }
    </>
  );
}

